// src/components/home/Features.jsx
import React from 'react';
import { motion } from 'framer-motion';

const smoothWavyEmoji = {
  initial: { y: 0 },
  animate: {
    y: [0, -10, 0, 10, 0],
    transition: {
      duration: 2.5,
      repeat: Infinity,
      ease: "linear", // Using linear for a consistent smooth wave
    },
  },
};

const verySubtleMove = {
  initial: { x: 0 },
  animate: {
    x: [0, 10, 0, -10, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut", // Keeping easeInOut for a gentle sway
    },
  },
};

const Features = () => {
  return (
    <section className="bg-light py-16">
      <div className="container mx-auto text-center">
        <motion.h2
          className="text-3xl font-heading font-bold mb-12 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          Why Choose Us? <motion.span aria-label="sparkles" role="img" style={{ marginLeft: '0.5rem' }} variants={smoothWavyEmoji} animate="animate">✨</motion.span>
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.span aria-label="teacher" role="img" className="text-4xl mb-4" variants={verySubtleMove} animate="animate">🧑‍🏫</motion.span>
            <h3 className="text-xl font-heading font-semibold mb-4">Expert Instructors</h3>
            <p className="text-gray-600">Learn from medical professionals with years of experience and expertise in exam preparation.</p>
          </motion.div>
          <motion.div
            className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <motion.span aria-label="books" role="img" className="text-4xl mb-4" variants={smoothWavyEmoji} animate="animate">📚</motion.span>
            <h3 className="text-xl font-heading font-semibold mb-4">Comprehensive Courses</h3>
            <p className="text-gray-600">Our courses cover everything you need to succeed in FMGE and NEET PG exams.</p>
          </motion.div>
          <motion.div
            className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <motion.span aria-label="person doing hand massage" role="img" className="text-4xl mb-4" variants={verySubtleMove} animate="animate">🧑‍⚕️</motion.span>
            <h3 className="text-xl font-heading font-semibold mb-4">Personalized Learning</h3>
            <p className="text-gray-600">Tailor your study plan based on your strengths and weaknesses for optimal results.</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Features;